module.exports = __webpack_public_path__ + "static/media/features-iphone-1.6e7c0565.png";